var _path, _path2, _g, _g2, _g3, _g4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectIcon04(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0885 2.29102H0.921875V15.1243H21.0885V2.29102Z",
    fill: "url(#paint0_linear_1582_2977)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 15.5098H8.25V20.1665H13.75V15.5098Z",
    fill: "url(#paint1_linear_1582_2977)"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: -6.95312,
    y: 6.79102,
    width: 35.916,
    height: 25.375
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(6px)",
      clipPath: "url(#bgblur_0_1582_2977_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1582_2977)",
    "data-figma-bg-blur-radius": 12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5052 18.791H5.50521C5.25207 18.791 5.04688 18.9962 5.04688 19.2493V19.7077C5.04688 19.9608 5.25207 20.166 5.50521 20.166H16.5052C16.7583 20.166 16.9635 19.9608 16.9635 19.7077V19.2493C16.9635 18.9962 16.7583 18.791 16.5052 18.791Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5052 18.791H5.50521C5.25207 18.791 5.04688 18.9962 5.04688 19.2493V19.7077C5.04688 19.9608 5.25207 20.166 5.50521 20.166H16.5052C16.7583 20.166 16.9635 19.9608 16.9635 19.7077V19.2493C16.9635 18.9962 16.7583 18.791 16.5052 18.791Z",
    fill: "url(#paint2_linear_1582_2977)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4639 19.291V19.666H5.54688V19.291H16.4639Z",
    stroke: "url(#paint3_linear_1582_2977)",
    strokeOpacity: 0.1
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: -10.6016,
    y: -9.34277,
    width: 43.2148,
    height: 36.1011
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(6px)",
      clipPath: "url(#bgblur_1_1582_2977_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1582_2977)",
    "data-figma-bg-blur-radius": 12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6126 2.65723H1.39844V14.7583H20.6126V2.65723Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6126 2.65723H1.39844V14.7583H20.6126V2.65723Z",
    fill: "url(#paint4_linear_1582_2977)",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: -11.5391,
    y: -10.167,
    width: 45.084,
    height: 39.5833
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(6px)",
      clipPath: "url(#bgblur_2_1582_2977_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_1582_2977)",
    "data-figma-bg-blur-radius": 12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6276 17.4163H1.3776C0.871146 17.4163 0.460938 17.0061 0.460938 16.4997V2.74967C0.460938 2.24322 0.871146 1.83301 1.3776 1.83301H20.6276C21.1341 1.83301 21.5443 2.24322 21.5443 2.74967V16.4997C21.5443 17.0061 21.1341 17.4163 20.6276 17.4163ZM1.3776 3.20801V14.208C1.3776 14.461 1.58294 14.6663 1.83594 14.6663H20.1693C20.4223 14.6663 20.6276 14.461 20.6276 14.208V3.20801C20.6276 2.95501 20.4223 2.74967 20.1693 2.74967H1.83594C1.58294 2.74967 1.3776 2.95501 1.3776 3.20801Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6276 17.4163H1.3776C0.871146 17.4163 0.460938 17.0061 0.460938 16.4997V2.74967C0.460938 2.24322 0.871146 1.83301 1.3776 1.83301H20.6276C21.1341 1.83301 21.5443 2.24322 21.5443 2.74967V16.4997C21.5443 17.0061 21.1341 17.4163 20.6276 17.4163ZM1.3776 3.20801V14.208C1.3776 14.461 1.58294 14.6663 1.83594 14.6663H20.1693C20.4223 14.6663 20.6276 14.461 20.6276 14.208V3.20801C20.6276 2.95501 20.4223 2.74967 20.1693 2.74967H1.83594C1.58294 2.74967 1.3776 2.95501 1.3776 3.20801Z",
    fill: "url(#paint5_linear_1582_2977)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.960938 14.5967C1.11017 14.932 1.44532 15.166 1.83594 15.166H20.1689C20.5589 15.166 20.8943 14.933 21.0439 14.5986V16.5C21.0438 16.7301 20.858 16.9158 20.6279 16.916H1.37793C1.14772 16.916 0.961113 16.7302 0.960938 16.5V14.5967ZM1.37793 2.33301H1.44629C1.23053 2.42927 1.0572 2.6026 0.960938 2.81836V2.75C0.960938 2.51968 1.14761 2.33301 1.37793 2.33301ZM20.6279 2.33301C20.8581 2.33318 21.0439 2.51979 21.0439 2.75V2.81641C20.9475 2.60137 20.7739 2.42899 20.5586 2.33301H20.6279Z",
    stroke: "url(#paint6_linear_1582_2977)",
    strokeOpacity: 0.1
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_1582_2977)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.35768 9.43477L7.16089 7.23798L9.03364 5.36523C9.21193 5.18556 9.21055 4.89498 9.03043 4.71715C8.95434 4.64198 8.85443 4.59523 8.74764 4.58606L3.24764 4.12773C2.99555 4.10573 2.77326 4.29273 2.75172 4.54482C2.74943 4.57003 2.74943 4.59569 2.75172 4.6209L3.21005 10.1209C3.23205 10.373 3.45389 10.56 3.70643 10.538C3.81322 10.5288 3.91314 10.4825 3.98922 10.4069L5.86197 8.53415L8.05876 10.7309C8.42314 11.0825 9.00339 11.0724 9.35493 10.7085C9.69822 10.3533 9.69822 9.78998 9.35493 9.43477H9.35814H9.35768Z",
    fill: "white",
    fillOpacity: 0.16
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1582_2977",
    x: -6.95312,
    y: 6.79102,
    width: 35.916,
    height: 25.375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1582_2977"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_1582_2977_clip_path",
    transform: "translate(6.95312 -6.79102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5052 18.791H5.50521C5.25207 18.791 5.04688 18.9962 5.04688 19.2493V19.7077C5.04688 19.9608 5.25207 20.166 5.50521 20.166H16.5052C16.7583 20.166 16.9635 19.9608 16.9635 19.7077V19.2493C16.9635 18.9962 16.7583 18.791 16.5052 18.791Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1582_2977",
    x: -10.6016,
    y: -9.34277,
    width: 43.2148,
    height: 36.1011,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1582_2977"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_1582_2977_clip_path",
    transform: "translate(10.6016 9.34277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6126 2.65723H1.39844V14.7583H20.6126V2.65723Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_1582_2977",
    x: -11.5391,
    y: -10.167,
    width: 45.084,
    height: 39.5833,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1582_2977"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_2_1582_2977_clip_path",
    transform: "translate(11.5391 10.167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6276 17.4163H1.3776C0.871146 17.4163 0.460938 17.0061 0.460938 16.4997V2.74967C0.460938 2.24322 0.871146 1.83301 1.3776 1.83301H20.6276C21.1341 1.83301 21.5443 2.24322 21.5443 2.74967V16.4997C21.5443 17.0061 21.1341 17.4163 20.6276 17.4163ZM1.3776 3.20801V14.208C1.3776 14.461 1.58294 14.6663 1.83594 14.6663H20.1693C20.4223 14.6663 20.6276 14.461 20.6276 14.208V3.20801C20.6276 2.95501 20.4223 2.74967 20.1693 2.74967H1.83594C1.58294 2.74967 1.3776 2.95501 1.3776 3.20801Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_1582_2977",
    x: 2.75,
    y: 4.12598,
    width: 6.86328,
    height: 8.86206,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1582_2977"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1582_2977",
    x1: 0.921875,
    y1: 2.29102,
    x2: 22.7361,
    y2: 10.9952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FF97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2C32FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1582_2977",
    x1: 8.25,
    y1: 15.5098,
    x2: 14.5775,
    y2: 17.4074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FF97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2C32FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1582_2977",
    x1: 5.04688,
    y1: 18.791,
    x2: 7.60432,
    y2: 24.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#5C6DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1582_2977",
    x1: 5.41927,
    y1: 18.8535,
    x2: 16.9635,
    y2: 18.8535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1582_2977",
    x1: 1.39844,
    y1: 2.65723,
    x2: 22.1227,
    y2: 11.0127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#5C6DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1582_2977",
    x1: 0.460938,
    y1: 1.83301,
    x2: 24.1071,
    y2: 9.95632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#5C6DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1582_2977",
    x1: 1.11979,
    y1: 2.54134,
    x2: 21.5443,
    y2: 2.54134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectIcon04);
export default __webpack_public_path__ + "static/media/project-icon04.7450654c6e4308ae188b55e938eec466.svg";
export { ForwardRef as ReactComponent };